var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{ref:"left-sidebar",staticClass:"col-md-2 d-none d-md-block sidebar",style:(_vm.brandedNavStyle)},[_c('div',{staticClass:"sidebar-sticky"},[_c('SidebarContent',{attrs:{"profile":_vm.profile,"branding":_vm.branding}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }